import { BodyText, Button, Heading } from '@farol-ds/react'
import { BoxLockVariationType } from '@jusbrasil-web/shared-apollo-client/types'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect } from 'react'

import { CustomBenefitsList } from '../custom-benefits-list'
import { getModalContentByLockVariationType } from './benefits'
import styles from './benefits-lock-content.module.scss'

interface BenefitsLockContentProps {
  lockVariationType: BoxLockVariationType
  handleOnClick: () => void
  eventProperties?: {
    app_id?: string | null
    from_component?: string | null
    feature?: string | null
    next_plan?: number | null
    current_plan?: number | null
    pid?: number | null
  }
}

function getEventNameByLockVariationType(
  lockVariationType: BoxLockVariationType,
  action: 'View' | 'ButtonClicked'
): string {
  switch (lockVariationType) {
    case BoxLockVariationType.CaseTrackingBgCheckFromBgCheckOffersLock:
      return `Box.BenefitsCaseTrackingBgCheckFromBgCheckOffers${action}`
    case BoxLockVariationType.CaseTrackingBgCheckFromLawsuitOffersLock:
      return `Box.BenefitsCaseTrackingBgCheckFromLawsuitOffers${action}`
    default:
      return `Box.BenefitsLock${action}`
  }
}

export function BenefitsLockContent({
  lockVariationType,
  handleOnClick,
  eventProperties,
}: BenefitsLockContentProps) {
  const modalContent = getModalContentByLockVariationType(lockVariationType)

  useEffect(() => {
    const eventName = getEventNameByLockVariationType(lockVariationType, 'View')
    sendMetrics(eventName, eventProperties?.pid?.toString() || null, {
      app_id: eventProperties?.app_id,
      from_component: eventProperties?.from_component,
      feature: eventProperties?.feature,
      next_plan: eventProperties?.next_plan,
      current_plan: eventProperties?.current_plan,
      modal_type: lockVariationType,
    })
  }, [lockVariationType, eventProperties])

  if (!modalContent) {
    return null
  }

  const { benefits, title, subtitle, buttonText } = modalContent

  const handleButtonClick = () => {
    const eventName = getEventNameByLockVariationType(lockVariationType, 'ButtonClicked')
    sendMetrics(eventName, eventProperties?.pid?.toString() || null, {
      app_id: eventProperties?.app_id,
      from_component: eventProperties?.from_component,
      feature: eventProperties?.feature,
      next_plan: eventProperties?.next_plan,
      current_plan: eventProperties?.current_plan,
      modal_type: lockVariationType,
    })
    handleOnClick()
  }

  return (
    <>
      <div className={styles.headerTitle} data-testid="benefits-lock-content">
        <Heading size="lg">
          <span
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </Heading>
        <BodyText size="md" className={styles.subtitle}>
          <span
            dangerouslySetInnerHTML={{
              __html: subtitle,
            }}
          />
        </BodyText>
      </div>
      <div className={styles.card}>
        <BodyText size="md" className={styles.cardTitle}>
          <span
            dangerouslySetInnerHTML={{
              __html: 'Com a atualização, você ganha:',
            }}
          />
        </BodyText>

        <BodyText size="md" className={styles.cardSubtitle}>
          <span
            dangerouslySetInnerHTML={{
              __html: 'Todos os benefícios do seu plano atual mais...',
            }}
          />
        </BodyText>
        <CustomBenefitsList customBenefits={benefits} />
      </div>
      <div className={styles.button}>
        <Button kind="primary" block className={styles.firstButton} onClick={handleButtonClick}>
          {buttonText}
        </Button>
      </div>
    </>
  )
}
